export default function useUtils() {
    /**
     * Create a cloned instance of a json object.
     */
    const clone = (json) => {
      if (json) {
        return JSON.parse(JSON.stringify(json))
      }
  
      return null
    }
  
    /**
     * Returns true if two json objects are equal.
     */
    const isEqual = (json1, json2) => {
      return JSON.stringify(json1) == JSON.stringify(json2)
    }
  
    const isNode = () => {
      return typeof window === 'undefined'
   }
   
    return { clone, isEqual, isNode }
}